import Vue from 'vue'
import state from 'lib/appState'
import 'modules/certification-icons/certification-icons.vue'

export default el => new Vue({
  el,
  data () {
    const product = window.HU.product

    const listFlavors = product['options_with_values'].find((option) => {
      return option.name === 'Flavor'
    }).values

    return {
      state,
      product,
      headline: '',
      description: '',
      background: '',
      flavor: '',
      image: '',
      icons: [],
      sections: [],
      listFlavors
    }
  },
  created () {
    const activeVariant = this.state.activeVariant
    this.updateData(activeVariant)
  },
  watch: {
    'activeVariant': {
      handler (activeVariant) {
        this.updateData(activeVariant)
      }
    }
  },
  computed: {
    activeVariant () {
      return this.state.activeVariant
    }
  },
  methods: {
    updateData (activeVariant) {
      const variantDefault = this.product.variants[0] || []
      this.headline = activeVariant.simple_ingredients_headline || variantDefault.simple_ingredients_headline
      this.description = activeVariant.simple_ingredients_description || variantDefault.simple_ingredients_description
      this.background = activeVariant.simple_ingredients_background || variantDefault.simple_ingredients_background
      this.icons = (activeVariant.certificate_icons.length > 0) ? activeVariant.certificate_icons : variantDefault.certificate_icons
      this.image = activeVariant.no_section_bg || variantDefault.no_section_bg
      this.sections = (activeVariant.no_section.length > 0) ? activeVariant.no_section : variantDefault.no_section
      this.flavor = activeVariant.flavor_bg || variantDefault.flavor_bg
    },
    onInputChange ({name, value}) {
      Vue.set(this.state.selectedOptions, 'Flavor', value)
    },
    getListOptions () {
      return this.listFlavors
    },
    getInitialFlavor () {
      return this.state.selectedOptions['Flavor']
    }
  }
})
